import AgentPanel from '@/components/agent/AgentPanel';
import PageTitle from '@/components/core/PageTitle';
import { useIsFeatureEnabled } from '@/stores/settingsStore';
import { Outlet } from 'react-router';

const ProjectRoute = () => {
  const isAgentEnabled = useIsFeatureEnabled('agent');

  return (
    <div className="flex flex-col bg-white shadow-lg shadow-slate-200 rounded-t-lg size-11/12 h-full overflow-hidden">
      <PageTitle className="bg-primary text-primary-content" />
      <Outlet />
      {isAgentEnabled && <AgentPanel />}
    </div>
  );
};

export default ProjectRoute;
